import script from "./ProductEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductEditView.vue?vue&type=script&setup=true&lang=js"

import "./ProductEditView.vue?vue&type=style&index=0&id=1315ccf9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1315ccf9"]])

export default __exports__